import type { IdentityField } from '../components/DocumentIdentityStrip';

/**
 * The "Document No." fact shown on the document, edit and review pages.
 *
 * A number is minted automatically the first time a run is promoted to the baseline (uploads
 * get theirs on creation), so a missing number means exactly "nothing promoted yet". A bare dash
 * left people guessing whether something was broken or waiting on them; the label says what
 * will happen and that no action is needed. Rendered muted so it never reads as a real number.
 */
export function documentNumberField(number: string | null | undefined): IdentityField {
  if (number) return { label: 'Document No.', value: number, mono: true, muted: false };
  return { label: 'Document No.', value: 'Assigned on promote', mono: false, muted: true };
}
